import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { timeout } from 'rxjs';
import { AuthService } from '@guard/auth.service';
import { environment } from '@env';

const DEFAULT_TIMEOUT = environment.requestTimeout;

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);

  const timeoutValue = Number(req.headers.get('timeout') || DEFAULT_TIMEOUT);

  // Ignore KC auth requests but include custom controllers
  if (!req.url.includes('auth/realms') || req.url.includes('/custom')) {
    let headers = req.headers.set('Authorization', `Bearer ${authService.getToken()}`);

    // Only set Content-Type on requests that have a body
    if (req.body !== null) {
      headers = headers.set('Content-Type', 'application/json');
    }

    const authReq = req.clone({ headers });

    return next(authReq).pipe(timeout(timeoutValue));
  }

  return next(req).pipe(timeout(timeoutValue));
};
